import apiMiddleware from "../api/apiMiddleware";

// Get checkout data for offline booking
export const getCheckoutData = async (params) => {
  try {
    const queryString = new URLSearchParams({
      package_id: params.package_id,
      stay_category_id: params.stay_category_id,
      booking_date: params.booking_date,
      adult_count: params.adult_count,
      child_count: params.child_count,
      infant_count: params.infant_count,
      package_price_rate_id: params.package_price_rate_id,
    }).toString();

    const response = await apiMiddleware.get(
      `/package-checkout-data?${queryString}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Create offline booking
export const createOfflineBooking = async (data) => {
  try {
    const response = await apiMiddleware.post(
      "/package-offline-booking-supplier",
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
